import styled, { css } from 'styled-components'

export const Section = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`

export const SectionTitle = styled.div`
    font-weight: 600;
    font-size: 16px;
    line-height: 28px;
`
export const SectionContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`

export const CompanyBox = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`
export const SubTitle = styled.div`
    font-size: 14px;
    line-height: 20px;
    color: #333;
    margin-bottom: 1rem;
    span {
        background-color: #ff7d55;
        font-size: 12px;
        line-height: 11px;
        color: #fff;
        font-weight: 600;
        border-radius: 12px;
        padding: 5px 10px;
    }
`
export const WrapSwitcher = styled.div`
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    margin-top: 8px;
`
export const WrapSwitcherMobile = styled.div`
    padding: 16px;
    background: #fff;
    border-radius: 6px;
    border: 1px solid #ebebeb;
    margin-bottom: 8px;
`
